(function ( $ ) {
	var $win = $(window);
	var $doc = $(document);

	$.fn.fitTextCheck = function() {

		return this.each(function() {

			var el = $(this),
			text = el.find('h2'),
			fontSize = parseInt( text.css('font-size') ),
			lastFontSize = fontSize,
			containerBounds = el.height(),
			textBounds = text.height();

			text.css('visibility', 'hidden');

			if( textBounds > containerBounds ) {
				while( textBounds > containerBounds ) {
					lastFontSize = fontSize;
					fontSize--;
					text.css('font-size', fontSize + 'px');

					textBounds = text.height();

					if( textBounds < containerBounds ) {
						break;
					}

				}
			}else{

				while( textBounds < containerBounds ) {
					lastFontSize = fontSize;
					fontSize++;
					text.css('font-size', fontSize + 'px');

					textBounds = text.height();

					if( textBounds > containerBounds ) {
						text.css('font-size', lastFontSize + 'px');
						break;
					}
				}
			}

			var textWidth = text.width(),
			actualWidth = text.find('a').width();
			if( actualWidth > textWidth ) {
				while( actualWidth > textWidth ) {
					lastFontSize = fontSize;
					fontSize--;
					text.css('font-size', fontSize + 'px');

					actualWidth = text.find('a').width();

					if( actualWidth < textWidth ) {
						break;
					}
				}
			}

			text.css('visibility', 'visible');

		});

	};

}( jQuery ));